// TermsAndConditions.js
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  text-align: left;
  h1 {
    color: rgb(33, 37, 67);
    text-overflow: ellipsis;
    font-size: 14px;
    font-family: Montserrat, sans-serif;
    font-weight: 700;
    text-align: center;
    align-self: stretch;
    flex-shrink: 0;
    margin-bottom: 12px;
  }
  h2 {
    font-family: Montserrat;
    font-weight: 700;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0%;
    color: #212543;
    margin-bottom: 12px;
  }
  ul {
    margin-left: 30px;
     padding-left: 2em;
  }
  ol {
    margin-left: 30px;
    list-style-type: lower-alpha;
  }
  li {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0%;
    color: rgba(33, 37, 67, 1);
    margin-bottom: 8px;
  }
  p {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0%;
    color: rgba(33, 37, 67, 1);
    margin-bottom: 12px;
  }
  span {
    font-family: Montserrat;
    font-weight: 700;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0%;
    color: rgba(33, 37, 67, 1);
    margin-bottom: 12px;
  }
`;
const Frame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  gap: 12px;
`;

export default function Terms() {
  return (
    <Wrapper>
      <Frame>
        <Logo>
          <Logo1>
            <Vector xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M8.30052 0C9.53868 0 10.6512 0.169308 11.6378 0.507912C12.6246 0.846504 13.4663 1.32532 14.1631 1.94434C14.8592 2.56392 15.391 3.31847 15.7585 4.20798C16.1261 5.09748 16.31 6.08434 16.3105 7.16854C16.3105 8.2519 16.1266 9.22882 15.7585 10.0993C15.3906 10.9698 14.8588 11.7099 14.1631 12.3197C13.4662 12.9288 12.6245 13.3979 11.6378 13.7268C10.6513 14.0557 9.5388 14.2202 8.30052 14.2205L4.58556 14.2205L4.58556 19.4442L0 19.4442L0 0L8.30052 0ZM8.01012 10.1865C9.15168 10.1865 10.0368 9.92087 10.6655 9.38938C11.2942 8.85791 11.6088 8.12755 11.6095 7.19832C11.6095 6.25078 11.2949 5.51077 10.6655 4.97832C10.0361 4.44588 9.15096 4.18014 8.01012 4.18112L4.58556 4.18112L4.58556 10.1865L8.01012 10.1865Z"
              />
            </Vector>
            <Vector_0001 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M7.19784 0C8.2032 0 9.11736 0.202801 9.94044 0.608401C10.7635 1.01399 11.4552 1.5944 12.0155 2.34965L12.0155 0.260148L16.3685 0.260148L16.3685 15.5834L12.0155 15.5834L12.0155 13.5241C11.5702 14.2399 10.9171 14.8058 10.0565 15.2217C9.19572 15.6377 8.24292 15.8456 7.19784 15.8455C6.153 15.8455 5.19036 15.6471 4.30992 15.2505C3.44604 14.8661 2.67048 14.3078 2.0316 13.6107C1.39296 12.9144 0.894841 12.0823 0.537241 11.1143C0.179641 10.1463 0.00048 9.08242 0 7.9225C0 6.74278 0.174121 5.66421 0.522601 4.68672C0.870961 3.70924 1.35936 2.8726 1.98792 2.17679C2.61732 1.47986 3.3768 0.942877 4.26624 0.565813C5.1558 0.188748 6.13296 0.000564 7.19784 0ZM8.2422 11.7818C8.80356 11.7818 9.31152 11.6852 9.76596 11.4921C10.2104 11.3059 10.6145 11.0352 10.9559 10.6949C11.2973 10.3515 11.5642 9.9415 11.7398 9.4903C11.923 9.02554 12.0148 8.51278 12.0155 7.9519C12.0155 6.81106 11.6671 5.8825 10.9705 5.16608C10.2739 4.44972 9.36444 4.09182 8.2422 4.09238C7.7004 4.09238 7.19736 4.18916 6.7332 4.38272C6.2832 4.56671 5.87376 4.83761 5.52852 5.17993C5.19 5.51867 4.92888 5.92486 4.74516 6.39862C4.56156 6.87226 4.46964 7.38982 4.46952 7.95106C4.46952 8.49286 4.56636 9.00082 4.75992 9.47482C4.95348 9.9487 5.2146 10.3551 5.54328 10.694C5.87208 11.0329 6.26868 11.2987 6.7332 11.4913C7.19772 11.6839 7.70064 11.7812 8.2422 11.7818Z"
              />
            </Vector_0001>
            <Vector_0002 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M7.1976 0.00125999C8.20368 0.00125999 9.11784 0.204049 9.94008 0.609649C10.7623 1.01524 11.454 1.59566 12.0151 2.35091L12.0151 0.261396L16.3687 0.261396L16.3687 15.5847L12.0151 15.5847L12.0151 13.5253C11.5698 14.2411 10.9169 14.8071 10.0561 15.223C9.19548 15.6389 8.24256 15.8469 7.1976 15.8467C6.15252 15.8467 5.19 15.6484 4.31016 15.2518C3.44628 14.8673 2.67084 14.3091 2.03184 13.612C1.39356 12.9156 0.8952 12.0835 0.53688 11.1155C0.17856 10.1476 -0.000359458 9.08366 5.42172e-07 7.92374C5.42172e-07 6.74402 0.174237 5.66545 0.522597 4.68797C0.871077 3.71048 1.35948 2.87384 1.98804 2.17804C2.61672 1.48126 3.37632 0.944052 4.26672 0.566424C5.15724 0.188808 6.13416 0 7.1976 0M8.24256 11.7825C8.8032 11.7825 9.31116 11.6859 9.76644 11.4927C10.2108 11.3063 10.6148 11.0356 10.9561 10.6955C11.2972 10.3521 11.5638 9.9419 11.7395 9.49094C11.9233 9.02618 12.0151 8.5133 12.0151 7.95254C12.0151 6.81171 11.6669 5.88302 10.9702 5.16671C10.2736 4.45034 9.36444 4.09244 8.24292 4.09301C7.70112 4.09301 7.19808 4.18979 6.73392 4.38335C6.28368 4.56697 5.87424 4.83792 5.52924 5.18056C5.18544 5.52718 4.91844 5.94242 4.74588 6.39926C4.56156 6.87374 4.46976 7.3913 4.47024 7.9517C4.47024 8.4935 4.56684 9.00134 4.76004 9.47534C4.95312 9.94934 5.21448 10.3558 5.54424 10.6947C5.87268 11.0335 6.26928 11.2993 6.73392 11.4918C7.19856 11.6844 7.70112 11.7819 8.24256 11.7825Z"
              />
            </Vector_0002>
            <Vector_0003 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M0 0.291192L4.3536 0.291192L4.3536 3.04804C4.99188 2.02301 5.7996 1.25874 6.77664 0.755244C7.75368 0.251748 8.80332 0 9.92556 0L9.92556 4.29629C9.11268 4.27714 8.36784 4.35448 7.69092 4.52832C7.014 4.70216 6.42864 4.9679 5.93496 5.32553C5.44692 5.67727 5.049 6.13964 4.77396 6.67472C4.49424 7.21652 4.35444 7.85504 4.35444 8.59028L4.35444 15.6136L0 15.6136L0 0.291192Z"
              />
            </Vector_0003>
            <Vector_0004 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M6.96516 0L6.96516 4.35335L10.6218 4.35335L10.6218 7.83587L6.96516 7.83587L6.96516 14.1334C6.96516 14.9658 7.1586 15.5124 7.54524 15.7733C7.932 16.0342 8.66736 16.126 9.7512 16.0489C9.80892 16.0489 9.95448 16.0395 10.1866 16.02C10.4185 16.0005 10.5642 15.9906 10.6218 15.9906L10.6218 19.7056C10.3897 19.7437 10.061 19.7825 9.63588 19.8216C9.21072 19.8607 8.88204 19.8802 8.64984 19.8799C6.57876 20.0149 5.055 19.6617 4.07844 18.8203C3.102 17.9789 2.61348 16.6681 2.61288 14.8879L2.61288 7.83587L0 7.83587L0 4.35335L2.61168 4.35335L2.61168 0L6.96516 0Z"
              />
            </Vector_0004>
            <Vector_0005 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M0 0.290352L4.3536 0.290352L4.3536 2.32195C4.9728 1.58686 5.69821 1.01608 6.52981 0.609648C7.36141 0.20322 8.22301 0 9.11341 0C9.92581 0 10.6662 0.145104 11.3334 0.435312C11.985 0.714324 12.5694 1.12998 13.0458 1.65419C13.5198 2.17685 13.8918 2.79601 14.163 3.51168C14.4342 4.22734 14.5698 5.01097 14.5698 5.86259L14.5698 15.6137L10.2162 15.6137L10.2162 6.79066C10.2162 5.93998 9.9786 5.25329 9.5046 4.73076C9.0318 4.20824 8.397 3.94699 7.6038 3.94699C7.1718 3.94457 6.7458 4.03914 6.3558 4.2237C5.96856 4.40807 5.62273 4.66987 5.34001 4.99301C5.04157 5.33596 4.806 5.72881 4.64388 6.15358C4.46952 6.59842 4.3728 7.08214 4.3536 7.60474L4.3536 15.6147L0 15.6147L0 0.290352Z"
              />
            </Vector_0005>
            <Vector_0006 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M4.55641 9.11182C4.73041 10.0795 5.14201 10.839 5.79001 11.3901C6.43681 11.9413 7.2552 12.2169 8.2428 12.2172C8.9388 12.2172 9.54241 12.072 10.056 11.7818C10.5684 11.4917 10.9224 11.0853 11.1156 10.5631L15.4392 10.5631C14.994 12.2849 14.124 13.6003 12.828 14.5095C11.532 15.4188 9.94561 15.8733 8.06761 15.8731C6.88801 15.8731 5.79961 15.6798 4.80361 15.293C3.80641 14.9064 2.9556 14.3651 2.2488 13.6693C1.5432 12.9727 0.991202 12.1358 0.596402 11.1589C0.200402 10.182 0.0012 9.1129 0 7.95166C0 6.79078 0.193201 5.72202 0.580801 4.74524C0.967201 3.76846 1.50841 2.9316 2.20561 2.23469C2.90161 1.53818 3.73441 0.991608 4.70161 0.59496C5.67001 0.198324 6.7332 0 7.8948 0C8.958 0 9.94921 0.164544 10.8684 0.493632C11.7888 0.82272 12.5916 1.27727 13.2768 1.85728C13.9668 2.44151 14.5344 3.1567 14.946 3.96146C15.372 4.78412 15.6228 5.68853 15.7008 6.67474C15.7392 7.12006 15.7632 7.47322 15.7728 7.73434C15.7836 7.99546 15.7884 8.19382 15.7872 8.3293C15.7872 8.60038 15.7776 8.8615 15.7584 9.11266L4.55641 9.11182ZM11.376 6.52906C11.2788 5.65846 10.926 4.97644 10.3176 4.48301C9.70801 3.98958 8.9388 3.74286 8.01 3.74286C7.158 3.74286 6.432 3.98958 5.832 4.48301C5.2332 4.97644 4.8264 5.65846 4.614 6.52906L11.376 6.52906Z"
              />
            </Vector_0006>
            <Vector_0007 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M0 0.291192L4.3536 0.291192L4.3536 3.04804C4.992 2.02301 5.7996 1.25874 6.7764 0.755244C7.7532 0.251748 8.8032 0 9.9252 0L9.9252 4.29629C9.1128 4.27714 8.3676 4.35448 7.6908 4.52832C7.014 4.70216 6.4284 4.9679 5.9352 5.32553C5.4468 5.67727 5.0496 6.13964 4.7736 6.67472C4.494 7.21652 4.3536 7.85504 4.3536 8.59028L4.3536 15.6136L0 15.6136L0 0.291192Z"
              />
            </Vector_0007>
            <Vector_0008 xmlns="http://www.w3.org/2000/svg">
              <path
                fill="rgb(26, 32, 66)"
                d="M4.37161 2.12768C4.37161 3.33419 3.4248 4.28118 2.1924 4.28118C0.973195 4.28118 0 3.33419 0 2.12768C0 0.946992 0.973195 0 2.1924 0C3.4236 0 4.37161 0.946992 4.37161 2.12768ZM0.544794 2.12768C0.544794 3.07468 1.2444 3.82699 2.2056 3.82699C3.1392 3.82699 3.82679 3.07447 3.82679 2.14027C3.82679 1.19328 3.1392 0.427764 2.1924 0.427764C1.2456 0.427764 0.544794 1.1935 0.544794 2.12768ZM1.854 3.24251L1.3608 3.24251L1.3608 1.11566C1.5564 1.07664 1.82879 1.05084 2.17919 1.05084C2.58119 1.05084 2.76361 1.11566 2.91841 1.2065C3.03601 1.29734 3.12599 1.466 3.12599 1.6735C3.12599 1.90699 2.94481 2.08867 2.68561 2.1665L2.68561 2.19356C2.89321 2.2714 3.0096 2.42706 3.0744 2.71259C3.1404 3.03692 3.18 3.16657 3.2304 3.2444L2.69881 3.2444C2.63401 3.16657 2.59439 2.97168 2.53079 2.72538C2.49239 2.49188 2.36281 2.38804 2.09041 2.38804L1.854 2.38804L1.854 3.24251ZM1.8672 2.036L2.10121 2.036C2.37361 2.036 2.59319 1.94518 2.59319 1.72468C2.59319 1.53 2.45161 1.40034 2.13961 1.40034C2.04841 1.39834 1.9572 1.40699 1.8672 1.42615L1.8672 2.036Z"
              />
            </Vector_0008>
            <Group1>
              <Image19 />
            </Group1>
          </Logo1>
        </Logo>
        <h1>
          PAARTNER LIMITED <br /> TERMS AND CONDITIONS
        </h1>
      </Frame>

      <p>
        By signing up to become a Member on the Paartner Referral Platform (the
        “<span>Platform</span>”), you agree to be bound by the following Terms
        and Conditions (the “<span>Terms</span>” or “
        <span>Terms and Conditions</span>”). Please ensure that you read these
        Terms and Conditions carefully before joining, as these Terms and
        Conditions constitute a legal agreement between Paartner Limited – Unit
        115, Accounts By Simply, 40 Gracechurch Street, London, England, EC3V
        0BT (“<span>Paartner</span>”, “<span>we</span>”, “<span>us</span>”) and
        you (the “<span>Member</span>” or “<span>you</span>”).
      </p>
      <p>
        We reserve the right, at our sole discretion, to change, modify, add or
        remove portions of these Terms, at any time without prior notice. When
        we change these Terms in a material way, a notice will be posted on the
        Paartner website (https://www.paartner.com/) (the “<span>Site</span>”)
        along with the updated Terms. It is your responsibility to periodically
        check these Terms for changes. Your continued access of the Platform
        following the posting of changes will mean that you accept and agree to
        the changes. If the modified Terms are not acceptable to you, your only
        recourse is to terminate your Membership and cease using the Platform.
      </p>
      <p>
        Any breach by you of these Terms and Conditions may result in
        termination or suspension of your status as Member and forfeiture of any
        outstanding Fixed Referral Rewards (as defined below) payable to you.
      </p>

      <h2>Account Registration</h2>
      <p>
        You must be a UK resident and at least 18 years of age or older to
        become a Member on the Paartner Referral Platform. You must provide your
        legal full name, a valid e-mail address, and any other information
        requested in order to complete the sign-up process to become a Member (a
        “<span>Paartner Account</span>”). By signing up, you confirm that you
        are legally capable of entering into binding agreements and accept full
        responsibility for your use of the Platform, including any tax or legal
        obligations that may arise.
      </p>
      <p>
        Your Paartner Account is for your sole use only and you may not share
        your username or password with any other person. You are solely
        responsible for maintaining the confidentiality and security of your
        login credentials. Any activities that occur under your account are your
        responsibility. Paartner is not liable for any loss or damage resulting
        from your failure to safeguard your credentials.
      </p>
      <p>
        You may not use the Paartner Account for any illegal or unauthorized
        purpose. You shall use the Platform in a lawful, respectful, and
        professional manner at all times. Without limitation, you agree not to:
      </p>
      <ul>
        <li>
          Misrepresent your identity – including impersonating another person,
          submitting false or misleading information, or using another person’s
          credentials or account.
        </li>
        <li>
          Engage in aggressive, misleading, deceptive, or coercive referral
          tactics, nor offer any unauthorized incentives, guarantees, or
          representations to the Prospective Client on behalf of Paartner or the
          Vendor.
        </li>
        <li>
          Upload or transmit unlawful or harmful content – including content
          that is defamatory, obscene, discriminatory, harassing, infringing of
          intellectual property or privacy rights, or otherwise prohibited by
          law.
        </li>
        <li>
          Engage in abusive, manipulative, or unethical behaviour harassment of
          other users, or exploitation of the Platform for unintended purposes.
        </li>
        <li>
          Compromise the security or functionality of the Platform – including
          attempting to introduce viruses, malware, or other harmful code;
          reverse-engineering; disrupting system integrity or performance; or
          circumventing any access restrictions or security features.
        </li>
        <li>
          Infringe any rights of Paartner or third parties – including misusing
          confidential information, violating intellectual property rights, or
          misrepresenting any affiliation with Paartner or Vendors.
        </li>
        <li>
          Attempt to bypass, circumvent, or undermine the functionality or
          processes of the Paartner Platform—including, but not limited to,
          making Referrals outside the Platform or soliciting Vendors or
          Prospective Clients directly.
        </li>
      </ul>

      <p>
        We reserve the right to reject, disable or terminate your Membership at
        any time if you violate these Terms, or otherwise engage in conduct
        deemed harmful to operation of the Platform or attempt to circumvent its
        intended processes. In such cases, any affected Referrals may be voided,
        and any associated Fixed Referral Rewards may be forfeited.
      </p>

      <h2>Referral Submission</h2>
      <p>
        Once you have signed up and created a Paartner Account you will be able
        to browse vendors who have registered to provide their services (each a
        “<span>Vendor</span>”) on the Platform. As a Member, you may submit
        Referrals via the Platform by providing basic details of a Prospective
        Client. As used herein, "<span>Referral</span>" means the act of
        submitting relevant, high level, contact information of a Prospective
        Client that will allow a Vendor to understand the potential opportunity
        via the Platform in accordance with these Terms and Conditions, and "
        <span>Prospective Client</span>" means a third party known to you whom
        you believe may be interested in purchasing a Vendor's products or
        services. Paartner and the Vendor reserve the right to validate such
        Referral and will contact the Prospective Client to confirm the
        authenticity and context of the submission.
        <br />
        <br />
        To be eligible for a Fixed Referral Reward, all Referrals must be
        submitted exclusively through the Paartner Platform in accordance with
        the referral process described therein. Referrals made through any other
        means, including direct communication with the Vendor or any third
        party, will not qualify for any reward.
        <br />
        <br />
        Prior to submitting a Referral, you must ensure that you have obtained
        the Prospective Client's consent to share any identifying details for
        the purposes of the Referral and their onward disclosure to the relevant
        Vendor. To enable validation of a Referral and execution of a Services
        Agreement, data submitted as part of a Referral will be shared with the
        applicable Vendor in accordance with applicable data protection laws.
        <br />
        <br />
        You agree to act in good faith and in a professional and respectful
        manner when referring Prospective Clients. You must also not engage in
        any conduct that, in Paartner’s sole discretion, is contrary to the
        spirit, values, or intended purpose of the Platform. This includes, but
        is not limited to, manipulative behavior designed to artificially
        generate Referrals, exploit system processes, or gain an unfair
        advantage over other Members.
        <br />
        <br />
        You must not submit Referrals where you have a conflict of interest,
        including but not limited to situations where the Prospective Client is
        a close personal relation, business associate, or where you may
        personally benefit from the outcome beyond the Fixed Referral Reward.
        <br />
        <br />
        You are solely responsible for ensuring that your participation in the
        Paartner Platform, including the submission of Referrals and receipt of
        Fixed Referral Rewards, does not breach any policies, contractual
        obligations, or codes of conduct that apply to you through your
        employment or other professional relationships. Paartner disclaims any
        responsibility or liability arising from your failure to comply with
        such obligations.
        <br />
        <br />
        Violations of the above obligations may result in immediate
        disqualification from the Platform, forfeiture of accrued Fixed Referral
        Rewards, and other legal or contractual remedies as appropriate.
      </p>

      <h2>Fixed Referral Rewards</h2>
      <p>
        For each Successful Referral (as defined below) which leads to the
        Prospective Client purchasing the products or services of the Vendor
        (each a “<span>Services Agreement</span>”), you shall earn a reward, as
        indicated with respect to the relevant Vendor at the time of your
        Referral (each a “<span>Fixed Referral Reward</span>”). We reserve the
        right to change the Fixed Referral Rewards structure at any time at our
        discretion, with such changes applying to any new Referrals made.
        <br />
        <br />
        Upon the entry into of the Services Agreement and receipt of
        corresponding payment by Paartner from the relevant Vendor, the Referral
        will be marked as ‘Successful’ within your Paartner Account and the
        amount of the Fixed Referral Reward(s) will be reflected in your
        Paartner Account.
      </p>

      <h2>Successful Referrals</h2>
      <p>
        To qualify as a referral for which Fixed Referral Rewards are payable
        (each a “<span>Successful Referral</span>”), the following conditions
        must be met:
      </p>
      <ol className={"custom-list"}>
        <li>
          a Services Agreement must be concluded within the time limit set by
          the relevant Vendor with respect to the relevant Referral;
        </li>
        <li>
          there must not be an Existing Business Relationship between the Vendor
          and the Prospective Client. An “
          <span>Existing Business Relationship</span>” means an active business
          relationship between the Vendor and a Prospective Client which
          predates the date of the relevant Referral being submitted;
        </li>
        <li>
          the Prospective Client must not be an “
          <span>Existing Prospective Client</span>”, defined as an interaction
          between the Vendor and a Prospective Client which has not cemented
          into an Existing Business Relationship, but where (i) such Prospective
          Client has shown an interest in the Vendor’s products or services; or
          (ii) the Prospective Client is actively being pursued by the Vendor’s
          sales representatives; or (iii) the Vendor has a timestamped entry in
          the its CRM system, or equivalent system, in each case which predates
          the date of Referral.
        </li>
      </ol>
      <p>
        Fixed Referral Rewards are one-off payments granted in respect of each
        individual, successful Referral. You acknowledge and agree that you
        shall not be entitled to receive any further Fixed Referral Rewards in
        connection with any subsequent renewals, extensions, repeat engagements,
        or additional services entered into between the Vendor and the
        Prospective Client.
        <br />
        <br />
        Referrals that are rejected by the Vendor for any reason—including but
        not limited to ineligibility, duplication, or failure to meet the
        Vendor’s internal criteria—shall not be eligible for a Fixed Referral
        Reward. Paartner shall have no obligation to investigate or challenge
        the Vendor’s decision, and such decisions shall be final.
      </p>

      <h2>Payment of Fixed Referral Rewards</h2>
      <p>
        The amount of the Fixed Referral Rewards and the applicable payment
        terms will be made available to you in your Paartner Account and via
        email.
        <br />
        You may request the payout of any accrued and available Fixed Referral
        Rewards in your Paartner Account, subject to applicable minimum
        withdrawal thresholds and verification requirements. Withdrawals can be
        made:
      </p>
      <ul>
        <li>
          via Stripe (subject to your account being properly linked and
          verified), or
        </li>
        <li>via direct bank transfer to a bank account nominated by you.</li>
      </ul>
      <p>
        Alternatively, you may elect to waive your right to receive payment, and
        request Paartner to donate the waived accrued Fixed Referral Rewards to
        a charity from among a list of Paartner official charities. <br />
        <br />
        All withdrawal and donation transactions are subject to applicable laws,
        service fees, and processing times. Paartner reserves the right to
        suspend or delay withdrawals in the event of suspected fraud, account
        misuse, or breach of these Terms. <br />
        <br />
        You must have a valid Stripe or UK bank account to receive Fixed
        Referral Rewards, as we don’t offer payments via any other method.
        Please note that Stripe or your bank may impose certain fees on the
        receipt of any payment. Such fees are not controlled by Paartner and
        shall be your responsibility. You are solely responsible for ensuring
        that your payment information is accurate and up to date. Paartner shall
        not be liable for failed payments due to incorrect or outdated details.{" "}
        <br />
        <br />
        You are solely responsible for determining and fulfilling any income
        tax, social security, or other tax obligations that may arise in
        connection with the Fixed Referral Rewards you receive. Paartner does
        not and will not withhold or remit any taxes on your behalf. You
        acknowledge and agree that it is your duty to determine your applicable
        tax reporting requirements and to remit all relevant taxes to the
        appropriate authorities. Paartner shall not be held liable for any
        failure by you to comply with your tax obligations. Paartner may report
        payments made to you to HMRC or other relevant tax authorities as
        required by applicable law. Such reporting does not constitute tax
        advice, nor does it alter your sole responsibility for assessing and
        fulfilling your own tax obligations. <br />
        <br />
        We reserve the right to withhold or disqualify any Fixed Referral
        Rewards that we determine, in our sole discretion, to have been earned
        through fraudulent, illegal, deceptive, misleading, or overly aggressive
        referral practices, or otherwise in violation of these Terms. Paartner’s
        determination in such matters shall be final and binding.
        <br />
        <br />
        If you do not request payout of your accrued Fixed Referral Rewards
        within twelve (12) months from the date they become eligible for
        withdrawal, you will be deemed to have irrevocably waived your right to
        receive such pa yment, and Paartner shall have no further liability or
        obligation in respect of those rewards. For clarity, Paartner does not
        operate as a custodian, trustee, or escrow agent of any unclaimed or
        unpaid rewards, and holds no fiduciary duty in relation to such funds.
      </p>
      <h2>Confidentiality</h2>
      <p>
        You agree that during your Membership on the Platform, and at all times
        thereafter, you shall treat as confidential and shall not disclose to
        any third party, or use for your own benefit (other than as necessary to
        fulfil your obligations under these Terms), any non-public, proprietary,
        or confidential information which you receive or obtain in connection
        with your use of the Platform or your participation in any Referral
        activity (“<span>Confidential Information</span>”). <br />
        <br />
        Confidential Information includes, without limitation:
        <ul>
          <li>Vendor contact details, pricing, or commercial terms;</li>
          <li>Prospective Client information submitted to the Platform;</li>
          <li>
            Platform business processes, systems, or referral methodologies;
          </li>
          <li>
            Any personal data or proprietary information related to Paartner,
            Vendors, or other Members that is not publicly available.
          </li>
        </ul>
        This obligation of confidentiality does not apply to information that:
        <ol className={"custom-list"}>
          <li>
            is or becomes generally available to the public other than through
            your breach of these Terms;
          </li>
          <li>
            is lawfully obtained from a third party who is not under an
            obligation of confidentiality; or
          </li>
          <li>
            is required to be disclosed by law, court order, or regulatory
            authority, in which case you shall, to the extent legally
            permissible, give prompt written notice to Paartner prior to such
            disclosure.
          </li>
        </ol>
        You acknowledge that unauthorized use or disclosure of Confidential
        Information may cause substantial harm to Paartner and/or its Vendors,
        and that Paartner may seek equitable relief, including injunctive
        relief, in addition to any other legal remedies available at law or in
        equity.
      </p>
      <h2>Intellectual Property Rights</h2>
      <p>
        You acknowledge that Paartner and/or its licensors (including the
        Paartner group of companies) shall retain ownership of all rights, title
        and interest in and to all of its intellectual property. Nothing herein
        shall be construed or interpreted as any grant of any license to you in
        relation to any of our intellectual property.
        <br />
        <br />
        You agree not to (whether directly or indirectly) apply for, register,
        acquire, use, purchase or obtain any trademarks, product names, brand
        names and/or Internet domain names which incorporates any word or words
        which are identical, or confusingly or substantially similar to any
        Paartner intellectual property or any variations or translations
        thereof.
      </p>
      <h2>Representations and Warranties</h2>
      <p>
        You hereby represent and warrant that during the term of your Membership
        on the Platform, you shall comply and shall conduct yourself in
        compliance with all applicable laws and regulations (including but not
        limited to relevant tax laws).
        <br />
        <br />
        Except as otherwise expressly provided herein, we make no representation
        or warranty, express or implied, in connection with the Platform or any
        Services Agreement, and we hereby disclaim any and all implied
        warranties, including all implied warranties of merchantability or
        fitness for a particular purpose. Paartner provides the Platform and
        access thereto on an "as is" and "as available" basis.
        <br />
        <br />
        We each acknowledge that, in entering into these Terms, no party has
        relied on any representation, undertaking or promise given by the other
        or be implied from anything said or written between us prior to entering
        into these Terms except as expressly set out herein.
      </p>
      <h2>Limitations of Liability</h2>
      <h2>
        TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW IN NO EVENT WILL:
        <ul style={{ fontWeight: "700" }} className="capital-list">
          <li style={{ fontWeight: "700" }}>
            PAARTNER OR EACH OF OUR (AND THE PAARTNER GROUP’S) OFFICERS,
            DIRECTORS, EMPLOYEES, SHAREHOLDERS OR AGENTS BE LIABLE TO YOU FOR
            ANY INDIRECT, DIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL,
            PUNITIVE, ACTUAL OR OTHER DAMAGES, INCLUDING, WITHOUT LIMITATION,
            LOSS OF REVENUE OR INCOME, LOST PROFITS, LOSS OF GOODWILL, SERVICE
            INTERRUPTION, COST OF SUBSTITUTE TRANSLATIONS, OR FOR ANY DAMAGES
            FOR PERSONAL OR BODILY INJURY OR EMOTIONAL DISTRESS SUFFERED OR
            INCURRED BY YOU OR ANY THIRD PARTY ARISING OUT OF OR IN CONNECTION
            WITH YOUR MEMBERSHIP ON THE PLATFORM OR USE OF OR INABILITY TO USE
            THE PLATFORM, THESE TERMS, ANY REFERRAL OR ANY SERVICES AGREEMENT
            WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE),
            PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, EVEN IF PAARTNER HAS
            BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THE ENTIRE RISK
            ARISING OUT OF YOUR MEMBERSHIP ON THE PLATFORM AND ACCESS THERETO
            AND USE THEREOF REMAINS WITH YOU;
          </li>
          <li style={{ fontWeight: "700" }}>
            PAARTNER BE RESPONSIBLE OR LIABLE WHATSOEVER IN ANY MANNER FOR ANY
            CONTENT POSTED ON OR AVAILABLE ON OR THROUGH THE PLATFORM (INCLUDING
            CLAIMS OF INFRINGEMENT RELATING TO THAT CONTENT), FOR YOUR USE OF
            THE PLATFORM, OR FOR THE CONDUCT OF THIRD PARTIES ON OR THROUGH THE
            PLATFORM; AND
          </li>
          <li style={{ fontWeight: "700" }}>
            PAARTNER’S MAXIMUM AGGREGATE LIABILITY (EXCEPT FOR OUR OBLIGATIONS
            TO TRANSFER AMOUNTS PAYABLE TO YOU PURSUANT TO THESE TERMS) ARISING
            OUT OF OR IN CONNECTION WITH YOUR MEMBERSHIP ON THE PLATFORM OR USE
            OF OR INABILITY TO USE THE PLATFORM, THESE TERMS, ANY REFERRAL OR
            ANY SERVICES AGREEMENT, EXCEED THE FIXED REFERRAL REWARDS WE HAVE
            PAID OR OWE IN THE TWELVE (12) MONTH PERIOD PRIOR TO THE EVENT
            GIVING RISE TO THE LIABILITY, OR ONE HUNDRED GBP (£100), IF NO SUCH
            PAYMENTS HAVE BEEN MADE, AS APPLICABLE.
          </li>
        </ul>
      </h2>

      <h2>Indemnification</h2>
      <p>
        You agree to release, defend, indemnify and hold harmless Paartner, its
        shareholders, officers, subsidiaries, affiliates, successors, assigns,
        directors, officers, agents, service providers, suppliers and employees,
        from and against any and all claims, damages (compensatory, direct,
        incidental, consequential or otherwise), obligations, losses, injuries,
        liabilities, costs or debt, and expenses (including but not limited to
        attorneys' fees) of any kind arising from or in any way connected with:
      </p>

      <ul className="roman-list">
        <li>your Membership on the Platform and your Paartner Account;</li>
        <li>your use of and access to the Platform; </li>
        <li>your violation of any term of these Terms; </li>
        <li>
          your failure to comply with applicable data protection obligations; or
        </li>
        <li>
          your violation of any third party right, including without limitation
          any copyright, trademark, trade secret or other property, or privacy
          right.
        </li>
      </ul>
      <h2>Anti Bribery</h2>
      <p>
        You must comply with all applicable anti-bribery and anti-corruption
        laws, including the UK Bribery Act 2010. You shall not, directly or
        indirectly, offer, give, solicit, or accept any bribe or other improper
        inducement in connection with any Referral or your use of the Platform.
        This includes any attempt to influence a Prospective Client, Vendor, or
        any third party through gifts, payments, or favours in exchange for
        business or referral opportunities. Any breach of this clause will
        result in immediate termination of your Paartner Account, forfeiture of
        all unpaid Fixed Referral Rewards, and may be reported to relevant
        authorities.
      </p>
      <h2>Data Protection and Privacy</h2>
      <p>
        All personal data processed through the Platform shall be handled in
        accordance with applicable data protection laws in force from time to
        time in the United Kingdom applicable to data protection and privacy
        including, but not limited to, the UK GDPR (the retained EU law version
        of the General Data Protection Regulation ((EU) 2016/679), as it forms
        part of the law of England and Wales, Scotland, and Northern Ireland by
        virtue of section 3 of the European Union (Withdrawal) Act 2018); the
        Data Protection Act 2018 (and regulations made thereunder); and the
        Privacy and Electronic Communications Regulations 2003 as amended.
        <br />
        <br />
        You agree not to submit the personal data of any Prospective Client
        without having obtained their explicit, informed consent for such
        processing and sharing. <br />
        <br />
        Paartner’s role with respect to personal data shared through the Partner
        Platform is detailed in our Privacy Policy, which forms an integral part
        of these Terms and Conditions.
      </p>
      <h2>Term and Termination</h2>
      <p>
        {" "}
        The term of your Membership on the Platform will begin upon creation of
        your Paartner Account and will end when terminated by either you or us.
        Such termination may be at any time, with or without cause, by giving
        the other party notice of termination (either through your Paartner
        Account, email or by post).
        <br />
        <br />
        In our sole discretion and for any reason and at any time, we may
        suspend or terminate your Membership on the Platform and your Paartner
        Account. Such termination will, in case your activities are in breach of
        these Terms, result in the forfeiture of all potential or accrued Fixed
        Referral Rewards. Upon the termination of your Membership, you will
        immediately cease use of your Paartner Account.
      </p>
      <h2>Miscellaneous</h2>
      <p>
        These Terms constitute the entire understanding and agreement between
        Paartner and you and supersedes and replaces any previous arrangements,
        understanding or agreement (whether oral or written) relating to the
        subject matter hereof.
        <br />
        <br />
        If at any time any provision of these Terms shall be held to be illegal,
        void, invalid or unenforceable in whole or in part by any court or
        administrative body in any jurisdiction, then such provision shall be
        enforced to the maximum extent permissible so as to affect our intent
        and (a) to the extent that it is illegal, void, invalid or unenforceable
        be given no effect and shall be deemed not to be included in these
        Terms; and (b) not affect or impair the legality, validity or
        enforceability in that jurisdiction of any other provision of these
        Terms; or the legality, validity or enforceability under the law of any
        other jurisdiction of such provision or any other provision of these
        Terms; and we shall use all reasonable endeavors to replace such a
        provision with a valid and enforceable substitute provision which
        carries out, as closely as possible, the intentions of these Terms.
        <br />
        <br />
        Our rights and remedies shall not be affected by any failure by us to
        exercise or delay in exercising any right or remedy or by the giving of
        any indulgence to you or by anything whatsoever except a specific waiver
        or release in writing by a duly authorized representative of Paartner
        and any such waiver or release shall not prejudice or affect any other
        rights or remedies we may have. No single or partial exercise of any
        right or remedy shall prevent any further or other exercise thereof or
        the exercise of any other right or remedy.
        <br />
        <br />
        Paartner shall not be liable for any failure or delay in performance
        under these Terms due to circumstances beyond its reasonable control,
        including but not limited to natural disasters, pandemics, cyberattacks,
        or government actions. Sections on Intellectual Property,
        Indemnification, Limitation of Liability, and Dispute Resolution shall
        survive termination of your Membership.
        <br />
        <br />
        You may not, without Paartner's prior written consent, assign or
        transfer these Terms, by operation of law or otherwise. Any attempt by
        you to assign or transfer these Terms, without such consent, shall be
        ineffective. Paartner may assign or transfer these Terms, at its sole
        discretion, without restriction. Subject to the foregoing, these Terms
        will bind and inure to the benefit of the parties, their successors and
        permitted assigns.
        <br />
        <br />
        These Terms do not and are not intended to confer any rights or remedies
        upon any person other than you and Paartner.
        <br />
        <br />
        Nothing herein is intended, nor should be construed, to create a
        partnership, joint venture, agency, franchise, sales representative, or
        employment relationship between us. You shall not enter into any
        contract or commitment with third parties as agent for or on our behalf;
        describe or present yourself as such an agent or in any way hold
        yourself out as being such an agent; or act on our behalf or represent
        us in any manner, or for any purpose.
        <br />
        <br />
        Any notices or other communications permitted or required hereunder,
        including those regarding modifications to these Terms, will be in
        writing and given by Paartner (i) via e-mail (in each case to the
        address that you provide) or (ii) by posting to the Platform. All
        notices given by you to us must be sent to us at support@paartner.com.
        For notices made by e-mail, the date of receipt will be deemed the date
        on which such notice is transmitted.
        <br />
        <br />
        Paartner reserves the exclusive right to interpret and apply these Terms
        and Conditions. All decisions made by Paartner regarding the
        administration of the Paartner Platform, eligibility of Referrals,
        allocation of Fixed Referral Rewards, and termination or suspension of
        Memberships shall be final and binding.
      </p>
      <h2>Disputes</h2>
      <p>
        To the fullest extent permitted by law, these Terms and any disputes,
        controversies or claims (collectively, “<span>Disputes”</span>) arising out of, or in
        connection with, its subject matter are governed by and construed in
        accordance with the laws of England and Wales without regard to its
        conflict-of-law provisions.
        <br />
        <br />
        You agree that any Disputes arising out of or in connection with these
        Terms, including any question regarding their existence, validity or
        termination, shall be referred to and finally resolved by arbitration
        under the Rules of the London Court of International Arbitration (LCIA),
        which Rules are deemed to be incorporated by reference into this clause.
        <ul>
          <li>The number of arbitrators shall be one (1).</li>
          <li>The seat of arbitration shall be London, United Kingdom.</li>
          <li>The language of the arbitration shall be English.</li>
        </ul>
        Nothing in this clause shall limit Paartner’s right to seek interim or
        injunctive relief in any competent court. <br />
        <br />
        Any claim or cause of action arising out of or related to these Terms
        must be filed within one (1) year after such claim or cause of action
        arose, or it shall be forever barred.
      </p>
      <h2>Feedback & Contacting Us</h2>
      <p>
        Your opinion counts. If you have any feedback or questions about these
        Terms, or any concerns or a complaints regarding its application, please
        e-mail us at support@paartner.com . One of our Team Members will contact
        you within a reasonable time after receipt of your e-mail.
      </p>
    </Wrapper>
  );
}

const Logo = styled.div`
  width: 165px;
  height: 24px;
  position: relative;
`;

const Logo1 = styled.div`
  width: 166px;
  height: 24px;
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Vector = styled.svg`
  width: 16px;
  height: 19px;
  position: absolute;
  left: 34px;
  top: 2px;
  right: 116px;
  bottom: 2px;
`;

const Vector_0001 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 52px;
  top: 6px;
  right: 98px;
  bottom: 2px;
`;

const Vector_0002 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 70px;
  top: 6px;
  right: 79px;
  bottom: 2px;
`;

const Vector_0003 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 90px;
  top: 6px;
  right: 66px;
  bottom: 2px;
`;

const Vector_0004 = styled.svg`
  width: 11px;
  height: 20px;
  position: absolute;
  left: 101px;
  top: 2px;
  right: 54px;
  bottom: 2px;
`;

const Vector_0005 = styled.svg`
  width: 15px;
  height: 16px;
  position: absolute;
  left: 114px;
  top: 6px;
  right: 37px;
  bottom: 2px;
`;

const Vector_0006 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 131px;
  top: 6px;
  right: 19px;
  bottom: 2px;
`;

const Vector_0007 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 149px;
  top: 6px;
  right: 7px;
  bottom: 2px;
`;

const Vector_0008 = styled.svg`
  width: 4px;
  height: 4px;
  position: absolute;
  left: 161px;
  top: 6px;
  right: 1px;
  bottom: 14px;
`;

const Group1 = styled.div`
  width: 25px;
  height: 24px;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Image19 = styled.div`
  width: 25px;
  height: 24px;
  background: url("https://d3nakrlcog1u3z.cloudfront.net/1750234477816-4b35a886422bef44a2225fae3321414ad27d07ab (1).png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0px;
  right: 0px;
`;
